import { Component, OnInit, ViewChild } from '@angular/core'
import { MatTabsModule } from '@angular/material/tabs'
import { AuthService } from '../../../core/services/auth/auth.service'
import { MatDialog } from '@angular/material/dialog'
import { MatButtonModule } from '@angular/material/button'
import { EmployeeManagementComponent } from '../employee-management/employee-management.component'
import { DriverManagementComponent } from '../driver-management/driver-management.component'
import { SupplierManagementComponent } from '../supplier-management/supplier-management.component'

@Component({
  selector: 'user-management',
  imports: [
    MatTabsModule,
    MatButtonModule,
    EmployeeManagementComponent,
    DriverManagementComponent,
    SupplierManagementComponent,
  ],
  templateUrl: './user-management.component.html',
  styleUrl: './user-management.component.scss',
  standalone: true,
  providers: [AuthService],
})
export class UserManagementComponent implements OnInit {
  constructor(
    private authService: AuthService,
    private dialog: MatDialog,
  ) {}

  @ViewChild(DriverManagementComponent)
  driverManagementComponent!: DriverManagementComponent
  screenSubClient: string = 'subcliente'
  screen: string = 'gerenciamento-usuarios'

  ngOnInit() {}

  checkPermission(permission: string, type: 'legal' | 'sub' | 'consultant') {
    let response = false
    if (type == 'legal') {
      response = this.authService.checkPermission(permission, this.screenSubClient)
    } else if (type == 'sub') {
      response = this.authService.checkPermission(permission, this.screenSubClient)
    } else if (type == 'consultant') {
      response = this.authService.checkPermission(permission, this.screenSubClient)
    }
    return response
  }

  teste() {
    this.driverManagementComponent?.uploadList()
  }
}
